import { Glyph } from '@/components/svgs/Glyph'
import { colors } from '@/constants/colors'
import { Pressable } from '@/ui/core/pressable'
import { cn } from '@/ui/utils'
import type { ReactNode } from 'react'
import { Text as RNText, View } from 'react-native'
import { listRowStyles } from './list-row.styles'

interface ListRowProps {
	label: string
	caption?: string
	onPress?: () => void
	/** What sits on the right; a chevron unless told otherwise. */
	right?: ReactNode
	/** A glyph or badge leading the label. */
	leading?: ReactNode
	className?: string
	accessibilityLabel?: string
	/** Black with white text for the one row a list wants seen. */
	tone?: 'white' | 'ink'
}

/** The brand's list item: a white square row, an uppercase H7 label, a chevron. */
export const ListRow = ({
	label,
	caption,
	onPress,
	right,
	leading,
	className,
	accessibilityLabel,
	tone = 'white',
}: ListRowProps) => {
	const styles = listRowStyles({ tone })

	return (
		<Pressable
			onPress={onPress}
			disabled={!onPress}
			accessibilityRole={onPress ? 'button' : undefined}
			accessibilityLabel={accessibilityLabel ?? label}
			className={cn(styles.row(), className)}
		>
			{leading}
			<View className={styles.body()}>
				<RNText className={styles.label()}>{label}</RNText>
				{!!caption && <RNText className={styles.caption()}>{caption}</RNText>}
			</View>
			{right ?? (
				<Glyph
					name="chevron"
					size={14}
					color={tone === 'ink' ? colors.white : colors.ink}
				/>
			)}
		</Pressable>
	)
}
